import { CbRicheditWidget } from './content-widget.model';
import { FbAttachmentWidget } from './form-widget-attachment.model';
import { FbBeforeAfterGalleriesWidget } from './form-widget-beforeafter-galleries.model';
import { FbBeforeAfterWidget } from './form-widget-beforeafter.model';
import { FbCheckboxCompositeWidget } from './form-widget-check.model';
import { FbDropdownWidget } from './form-widget-dropdown.model';
import { FbEmrMedicalHistoryWidget } from './form-widget-emr-medical-history.model';
import { FbEmrInsuranceInfoWidget } from './form-widget-emr-insurance-info.model';
import { FbEmrDemographicsWidget } from './form-widget-emr-demographics.model';
import { FbImageWidget } from './form-widget-image.model';
import { FbMatrixWidget } from './form-widget-matrix.model';
import { FbRadioCompositeWidget } from './form-widget-radio.model';
import { FbRicheditWidget } from './form-widget-richedit.model';
import { FbSignatureWidget } from './form-widget-signature.model';
import { FbTextareaWidget } from './form-widget-textarea.model';
import { FbTextboxWidget } from './form-widget-textbox.model';
import { Widget } from './form-widget.model';

export class WidgetBuilder {
  constructor() {}
  public static create(data: any): any {
    switch (data.name) {
      // Obsolete
      // case 'fb-beforeafter': {
      //     return new FbBeforeAfterWidget(data);
      // }
      case 'fb-beforeafter-bottox':
      case 'cb-beforeafter-bottox': {
        return new FbBeforeAfterWidget(data.name, data);
      }
      case 'fb-beforeafter-dysport':
      case 'cb-beforeafter-dysport': {
        return new FbBeforeAfterWidget(data.name, data);
      }
      case 'fb-beforeafter-emsculpt':
      case 'cb-beforeafter-emsculpt': {
        return new FbBeforeAfterWidget(data.name, data);
      }
      case 'fb-beforeafter-exilis-elite':
      case 'cb-beforeafter-exilis-elite': {
        return new FbBeforeAfterWidget(data.name, data);
      }
      case 'fb-beforeafter-juvederm':
      case 'cb-beforeafter-juvederm': {
        return new FbBeforeAfterWidget(data.name, data);
      }
      case 'fb-beforeafter-juvederm-ultra-xc':
      case 'cb-beforeafter-juvederm-ultra-xc': {
        return new FbBeforeAfterWidget(data.name, data);
      }
      case 'fb-beforeafter-juvederm-vollure-xc':
      case 'cb-beforeafter-juvederm-vollure-xc': {
        return new FbBeforeAfterWidget(data.name, data);
      }
      case 'fb-beforeafter-juvederm-voluma':
      case 'cb-beforeafter-juvederm-voluma': {
        return new FbBeforeAfterWidget(data.name, data);
      }
      case 'fb-beforeafter-juvederm-voluma-xc':
      case 'cb-beforeafter-juvederm-voluma-xc': {
        return new FbBeforeAfterWidget(data.name, data);
      }
      case 'fb-beforeafter-pelleve':
      case 'cb-beforeafter-pelleve': {
        return new FbBeforeAfterWidget(data.name, data);
      }
      case 'fb-beforeafter-radiesse-hands':
      case 'cb-beforeafter-radiesse-hands': {
        return new FbBeforeAfterWidget(data.name, data);
      }
      case 'fb-beforeafter-restylane-defyne':
      case 'cb-beforeafter-restylane-defyne': {
        return new FbBeforeAfterWidget(data.name, data);
      }
      case 'fb-beforeafter-restylane-silk':
      case 'cb-beforeafter-restylane-silk': {
        return new FbBeforeAfterWidget(data.name, data);
      }
      case 'fb-beforeafter-volbella':
      case 'cb-beforeafter-volbella': {
        return new FbBeforeAfterWidget(data.name, data);
      }
      // case 'cb-beforeafter-galleries':
      case 'fb-beforeafter-galleries': {
        return new FbBeforeAfterGalleriesWidget(data);
      }
      case 'fb-image': {
        return new FbImageWidget(data);
      }
      case 'fb-signature': {
        return new FbSignatureWidget(data);
      }
      case 'cb-richedit': {
        return new CbRicheditWidget(data);
      }
      case 'fb-richedit': {
        return new FbRicheditWidget(data);
      }
      case 'fb-textbox-composite': {
        return new FbTextboxWidget(data);
      }
      case 'fb-radio-composite': {
        return new FbRadioCompositeWidget(data);
      }
      case 'fb-checkbox-composite': {
        return new FbCheckboxCompositeWidget(data);
      }
      case 'fb-header': {
        data.properties.value.value = '<strong>' + data.properties.value.value + '</strong>';
        return new FbRicheditWidget(data);
      }
      case 'fb-text': {
        return new FbRicheditWidget(data);
      }
      case 'fb-textarea-composite': {
        return new FbTextareaWidget(data);
      }
      case 'fb-table': {
        const table = new Widget(data);
        table.name = 'fb-table';
        table.title = 'Table';
        return table;
      }
      case 'fb-matrix': {
        const matrix = new FbMatrixWidget(data);
        return matrix;
      }
      case 'fb-dropdown': {
        const dropdown = new FbDropdownWidget(data);
        return dropdown;
      }
      case 'fb-attachment': {
        const attachment = new FbAttachmentWidget(data);
        return attachment;
      }
      case 'fb-emr-medical-history': {
        const mh = new FbEmrMedicalHistoryWidget(data);
        return mh;
      }
      case 'fb-emr-insurance-info': {
        return new FbEmrInsuranceInfoWidget(data);
      }
      case 'fb-emr-demographics': {
        return new FbEmrDemographicsWidget(data);
      }
      default: {
        return new Widget(data);
      }
    }
  }
}
